import api from './AxiosInstance';

export class CreateMdctsActesService {

  getAllCreation = async () => {
    try {
      const response = await api.get(`/Actes/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; // Vous pouvez relancer l'erreur pour la gérer à un niveau supérieur si nécessaire
    }
  };



  addCreation = async (newCreation) => {
    try {


      const response = await api.post(`/Actes/add`, newCreation)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);

      throw error;
    }
  };


  updateCreation = async (updatedData) => {
    try {
      const response = await api.put(`/Actes/update`, updatedData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de la prestation :', error);
      throw error;
    }
  };

  updateExclusion = async (updatedData) => {
    try {
      const response = await api.put(`Actes/update/Exclusion`, updatedData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour des exclusions :', error);
      throw error;
    }
  };

  deleteCreation = async (numligne) => {
    try {
      const response = await api.delete(`Actes/delete/${numligne}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de la prestation :', error);
      throw error;
    }
  };

  deleteCreationLines = async (deleteData) => {
    try {
      const response = await api.post(`Actes/delete`, deleteData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de la prestation :', error);
      throw error;
    }
  };

  importActes = async (payload) => {
    try {
      const response = await api.post(`/Actes/Import/06`, payload);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de la prestation :', error);
      throw error;
    }
  };

}


